import React from 'react';
import {
  string, number, node, oneOfType, arrayOf, bool,
} from 'prop-types';

import { InfoSectionContainer, InfoSectionHeader, InfoSectionHeaderContainer } from './card-info-section.style';

/**
 * Info section component to be used in Cards.
 * @param {object} params - Object containing component props
 * @param {number} params.numCols - If true, section only single column
 * @param {string?} params.header - Header text. Not shown if not set
 * @param {element} params.headerContent - HTML Content to show in right hand side of section header
 * @param {element} params.children - Children HTML elements to show
 * @param {string} params.backgroundColor - Background color for the section
 * @param {string} params.testId - Testing id
 * @param {number} params.rowGap - Gap between rows
 * @return {elemement}
 */
const InfoSection = ({
  numCols,
  children,
  header,
  headerContent,
  removePadding,
  outlineBottom,
  testId,
  backgroundColor,
  rowGap,
}) => (
  <>
    { header && (
      <InfoSectionHeaderContainer data-testid={`${testId}-header`}>
        <InfoSectionHeader>{header}</InfoSectionHeader>
        {headerContent}
      </InfoSectionHeaderContainer>
    )}
    <InfoSectionContainer
      numCols={numCols}
      removePadding={removePadding}
      outlineBottom={outlineBottom}
      backgroundColor={backgroundColor}
      data-testid={testId}
      rowGap={rowGap}
    >
      {children}
    </InfoSectionContainer>
  </>

);

InfoSection.propTypes = {
  header: string,
  numCols: number,
  children: oneOfType([
    arrayOf(node),
    node,
  ]),
  removePadding: bool,
  outlineBottom: bool,
  backgroundColor: string,
  testId: string,
  headerContent: node,
  rowGap: number,
};

InfoSection.defaultProps = {
  header: null,
  numCols: 1,
  children: null,
  removePadding: false,
  outlineBottom: false,
  backgroundColor: null,
  testId: null,
  headerContent: null,
  rowGap: 0,
};

export default InfoSection;
